import { render, staticRenderFns } from "./ManageTemplateCategory.vue?vue&type=template&id=2e17463c"
import script from "./ManageTemplateCategory.vue?vue&type=script&lang=js"
export * from "./ManageTemplateCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports